import { useIsMutating } from 'react-query'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { IconButton, SxProps, Theme, Typography } from '@mui/material'

interface BackButtonProps {
  onClick: () => void
  withText?: boolean
}

const textStyle: SxProps<Theme> = (theme) => ({
  paddingLeft: '4px',
  color: 'text.secondary',
  fontSize: theme.typography.pxToRem(14),
})

export default function BackButton({ onClick, withText = false }: BackButtonProps): JSX.Element {
  const isMutating = useIsMutating()
  const disabled = !(isMutating === 0)

  return (
    <IconButton
      className="prev-page-btn"
      onClick={onClick}
      disabled={disabled}
      aria-label={withText ? undefined : 'Go back'}
    >
      <ArrowBackIcon />
      {withText && <Typography sx={textStyle}>Back</Typography>}
    </IconButton>
  )
}
